// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","dueTrainingIcon":"HomeEducation_dueTrainingIcon__yuuWH"};